import { HST_RATE, HST_DIVISOR } from "@/types/crm";

/**
 * Standardized HST and Profit calculations for Car Street
 */

export const calculateHST = (amount: number): number => {
  if (!amount) return 0;
  // amount is inclusive of HST, we want to extract the HST portion
  // Formula: amount * (rate / (100 + rate))
  return parseFloat((amount * (HST_DIVISOR - 100) / HST_DIVISOR).toFixed(2));
};

export const calculateNetPrice = (grossAmount: number): number => {
  if (!grossAmount) return 0;
  return parseFloat((grossAmount - calculateHST(grossAmount)).toFixed(2));
};

export const calculateProfit = (
  salePrice: number,
  tradeIn: number,
  purchaseCost: number,
  expenses: number
): number => {
  const taxableAmount = salePrice - tradeIn;
  const netRevenue = calculateNetPrice(taxableAmount);
  return parseFloat((netRevenue - purchaseCost - expenses).toFixed(2));
};
